import api from "./axios";

export const digioKycApi = {
  initKyc: async () => {
    const res = await api.post("/aadhaar/digio/init");
    return res.data;
  },

  getKycStatus: async () => {
    const res = await api.get("/aadhaar/digio/status");
    return res.data;
  },

  syncKyc: async () => {
    const res = await api.post("/aadhaar/digio/sync");
    return res.data;
  },
};
